import { MapLike } from '@iotv/iotv-v3-types';
import { UserAttributeDefs } from '../types/ModelTypes';
import { DeviceEnabledType } from './Device/DeviceEnabledType';

const typeName = 'Entity'

export type EntityProps = {
  name?: string
  type: string
  Category: string
}

type GenericEntityPayloadAttributes = {}

class Entity extends DeviceEnabledType {
  constructor(ob: MapLike<any>) {
    super(typeName, ob)
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'identification',
        validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
      },
      Category: {
        type: 'String',
        editable: true,
        label: 'Category',
        name: 'Category',
        description: 'identification',
        validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Category cannot contain invalid characters' },
      },
    }
  }

  /** Returns a zombie suitable to find a scoreconfig pseudoattribute for the entity
   */
  getScoreConfigZombie() {
    return {
      pk: this.pk,
      sk: `ScoreConfig:${this.id}_scoreConfig`,
      id: `${this.id}_scoreConfig`,
      type: 'ScoreConfig',
    }
  }
}

export { Entity }
